<template lang="html">
    <div id="additional-service-menu">
        <md-tabs :md-active-tab="activeTab">
            <md-tab id="tab-services" v-bind:to="{ name: 'AdditionalServices'}" md-label="Список услуг"></md-tab>
            <md-tab id="tab-services-prices" v-bind:to="{ name: 'AdditionalServicesPrices'}" md-label="Список цен"></md-tab>
        </md-tabs>
    </div>
</template>
<script>
    export default {
        name: 'additional-service-menu',
        data() {
            return {
                activeTab: null
            }
        },
        watch: {
            '$route'() {
                this.activeTab = 'tab-' + this.$route.meta.tab;
            }
        },
        created() {
            this.activeTab = 'tab-' + this.$route.meta.tab;
        }
    }
</script>



// WEBPACK FOOTER //
// AdditionalServicesMenu.vue?85f054b2